import { Injectable } from '@angular/core';
import { forkJoin, map, Observable } from 'rxjs';
import { DeveloperDto, ResourceDto, SingleApplicationDto, UserDto } from '@dto';
import { Account, Locale, Timezone } from '@model';
import {
  AccountService,
  ApplicationService,
  DeveloperService,
  EntityService,
  LocaleService,
  ResourceService,
  TimezoneService,
  UserService,
} from '@service';

@Injectable()
export class AdminResolver {
  constructor(
    private accountService: AccountService,
    private applicationService: ApplicationService,
    private desEntityService: EntityService,
    private developerService: DeveloperService,
    private timezoneService: TimezoneService,
    private localeService: LocaleService,
    private resourceService: ResourceService,
    private userService: UserService,
  ) {}

  resolve(): Observable<
    [Account[], Timezone[], Locale[], SingleApplicationDto[], UserDto[], ResourceDto[], DeveloperDto[]]
  > {
    const accounts$ = this.accountService.getAccounts();
    const resources$ = this.resourceService.resources$();
    const developers$ = this.developerService.developers$();
    const entities$ = this.desEntityService.entities$();
    const accountsMerged$ = forkJoin([accounts$, entities$]);

    const merged$: Observable<Account[]> = accountsMerged$.pipe(
      map(([accounts, entities]) => {
        return accounts.reduce((acc, account) => {
          const acctEntity = entities.find(entity => entity.extId === account.id);
          if (acctEntity) {
            acc.push({ ...account, entityId: acctEntity.id });
          } else {
            acc.push(account);
          }

          return acc;
        }, []);
      }),
    );

    const applications$ = this.applicationService.getApplications();
    const locales$ = this.localeService.getLocales();
    const timezones$ = this.timezoneService.getTimezones();
    const users$ = this.userService.users$();

    return forkJoin([merged$, timezones$, locales$, applications$, users$, resources$, developers$]);
  }
}
